import { roomData } from "./data";
import { RoomMembership } from "./types";

// 成员相关工具函数
export const memberUtils = {
  setRoomMembers(roomId: string, members: any[]) {
    roomData.roomMembers[roomId] = members.map(member => ({
      userId: member.userId,
      displayName: member.displayName || member.name || (typeof member.userId === 'string' ? member.userId.split('@')[0] : ''),
      avatarUrl: member.avatarUrl,
      membership: RoomMembership[(member.membership || '').toUpperCase() as keyof typeof RoomMembership] || RoomMembership.LEAVE
    }));
  },
  
  getRoomMembers(roomId: string) {
    return roomData.roomMembers[roomId] || [];
  },
  
  updateMember(
    roomId: string, 
    userId: string, 
    updates: {
      displayName?: string;
      avatarUrl?: string;
      membership: RoomMembership;
    } & { [key: string]: any } // 允许其他属性
  ) {
    if (!roomData.roomMembers[roomId]) {
      roomData.roomMembers[roomId] = [];
    }
    
    const memberIndex = roomData.roomMembers[roomId].findIndex(m => m.userId === userId);
    if (memberIndex !== -1) {
      // 更新现有成员
      roomData.roomMembers[roomId][memberIndex] = {
        ...roomData.roomMembers[roomId][memberIndex],
        ...updates,
        membership: RoomMembership[(updates.membership || '').toUpperCase() as keyof typeof RoomMembership] || RoomMembership.LEAVE
      };
    } else {
      // 添加新成员
      const { membership, ...restUpdates } = updates;
      roomData.roomMembers[roomId].push({
        userId,
        displayName: updates.displayName || (typeof userId === 'string' ? userId.split('@')[0] : ''),
        avatarUrl: updates.avatarUrl,
        membership: RoomMembership[(membership || '').toUpperCase() as keyof typeof RoomMembership] || RoomMembership.LEAVE,
        ...restUpdates
      });
    }
  }
};
